// Home page announcements a visitor can dismiss. Dismissal is remembered in
// this browser only, by announcement id: give a revised announcement a new id
// so it shows again. `until` (optional, YYYY-MM-DD) hides it for everyone after
// that day.
//
// Storage can be unavailable (private windows, blocked site data); then an
// announcement simply shows again on the next visit.

export const ANNOUNCEMENTS = {
  // Revised Form 425 and Bact bar code label instructions, May 2026
  bact_form_425: { id: 'bact-2026-05', until: null },
}

const KEY = 'pws_portal_dismissed_announcements'

function dismissedIds() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]')
  } catch (e) {
    return []
  }
}

export function isShown(a) {
  if (a.until && new Date() > new Date(a.until + 'T23:59:59')) return false
  return !dismissedIds().includes(a.id)
}

export function dismiss(a) {
  const ids = dismissedIds()
  if (!ids.includes(a.id)) ids.push(a.id)
  try {
    localStorage.setItem(KEY, JSON.stringify(ids))
  } catch (e) {
    // Hidden for this visit only.
  }
}
